import './polyfills.ts';

import * as $ from 'jquery';
window["$"] = $;
window["jQuery"] = $;

import { platformBrowserDynamic } from '@angular/platform-browser-dynamic';
import { enableProdMode } from '@angular/core';
import { environment } from './environments/environment';
import { AppModule } from './app/app.module';

if (environment.production) {
  enableProdMode();
}

platformBrowserDynamic().bootstrapModule(AppModule);



// WEBPACK FOOTER //
// C:/xampp/htdocs/roche/roche/src/main.ts